/* ==========================================================================
   CarFusionElements — ruhige Einblendungen beim Scrollen

   Bewusst zurueckhaltend: leichtes Aufblenden und ein kurzer Weg nach oben,
   versetzt pro Element. Kein Zoomen, kein Springen, kein Zappeln — Premium
   heisst kontrolliert.

   Wichtig: Der versteckte Zustand wird ausschliesslich ueber das Attribut
   data-reveal-bereit am <html> aktiviert, das dieses Skript selbst setzt.
   Laedt das Skript nicht oder ist JavaScript aus, bleibt alles sichtbar.
   ========================================================================== */

(function () {
  'use strict';

  var wurzel = document.documentElement;

  // Wer sich nicht bewegen will, bekommt keine Bewegung.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var AUSWAHL = [
    '.band__kicker', '.band__titel', '.band__text', '.band__schritt',
    '.band__knopf', '.band__newsletter',
    '.modellschau__kicker', '.modellschau__titel',
    '.datenblatt__kicker', '.datenblatt__titel', '.datenblatt__eintrag',
    '.section--page-width h2', '.section--page-width .text-block',
    '.card-gallery', '.collection-card__inner'
  ].join(',');

  function vorbereiten() {
    wurzel.setAttribute('data-reveal-bereit', '');

    var beobachter = new IntersectionObserver(
      function (eintraege) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.setAttribute('data-sichtbar', '');
          beobachter.unobserve(e.target);
        });
      },
      // Schwelle 0: sobald ein Pixel eintritt. Alles darueber koennte bei
      // sehr hohen oder sehr flachen Elementen nie ausloesen — dann bliebe
      // Text unsichtbar. Der Vorlauf kommt allein aus dem rootMargin.
      { rootMargin: '0px 0px -10% 0px', threshold: 0 }
    );

    document.querySelectorAll(AUSWAHL).forEach(function (el) {
      if (el.hasAttribute('data-reveal')) return;
      el.setAttribute('data-reveal', '');

      // Versatz innerhalb einer Gruppe, damit es nacheinander einlaeuft
      var geschwister = el.parentElement
        ? [].slice.call(el.parentElement.children).filter(function (k) {
            return k.matches(AUSWAHL);
          })
        : [];
      var i = geschwister.indexOf(el);
      el.style.setProperty('--reveal-verzug', (i > 0 ? Math.min(i, 5) * 90 : 0) + 'ms');

      beobachter.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vorbereiten);
  } else {
    vorbereiten();
  }

  // Im Theme-Editor werden Abschnitte neu geladen
  document.addEventListener('shopify:section:load', vorbereiten);

  /* Sicherheitsnetz: Sollte der Beobachter aus irgendeinem Grund nicht
     ausloesen, wird nach fuenf Sekunden alles sichtbar gemacht, was der
     Nutzer bereits erreicht hat. Lieber keine Animation als kein Text. */
  window.addEventListener('load', function () {
    setTimeout(function () {
      document.querySelectorAll('[data-reveal]:not([data-sichtbar])').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) {
          el.setAttribute('data-sichtbar', '');
        }
      });
    }, 5000);
  });
})();
